import { StatusPill } from '../../../../../ui'
import { Provenance, provenanceTone } from '../shared'

interface ProvenancePillProps {
    provenance?: Provenance | null
    /** Shown when the backend did not classify the record (older API responses). */
    fallback: string
    size?: 'sm'
}

/**
 * One glance at where a client came from: Claim Delivery API, an introducer,
 * the Sentinel website, a manual add, or a legacy store. Legacy systems are
 * flagged amber so nobody mistakes an old Zapped Cases / Olton Alexander
 * record for a live one.
 */
export const ProvenancePill = ({ provenance, fallback, size }: ProvenancePillProps) => {
    if (!provenance) {
        return (
            <StatusPill tone="accent" size={size}>
                {fallback}
            </StatusPill>
        )
    }
    return (
        <StatusPill
            tone={provenanceTone(provenance)}
            size={size}
            dot={provenance.legacy}
            title={provenance.detail ?? undefined}
        >
            {provenance.legacy ? `Legacy · ${provenance.system}` : provenance.system}
        </StatusPill>
    )
}
